const topics = {};

const pubsub = {
  on: (topic, listener) => {
    topics[topic] = topics[topic] || [];
    topics[topic].push(listener);

    const index = topics[topic].length - 1;

    return {
      end: () => {
        delete topics[topic][index];
      }
    };
  },
  once: (topic, listener) => {
    const event = pubsub.on(topic, (payload) => {
      listener(payload);
      event.end();
    });

    return event;
  },
  emit: (topic, payload) => {
    if (!topics[topic]) return;

    topics[topic].forEach(listener => listener(payload));
  }
};

export default pubsub;